import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { dataProcess } from "../../../api";
import { parserAPI } from "../../../utils/parser.jsx";
import { useDashboardContext } from "../../../contexts/NewDashboardContext";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

function App({ selectedStatus }) {
  const {
    selectedLocationOverview,
    selectedMachineOverview,
    dateRangeOverview,
  } = useDashboardContext();
  var themeColor = getComputedStyle(document.body)
    .getPropertyValue("--bs-theme")
    .trim();
  var inverse = getComputedStyle(document.body)
    .getPropertyValue("--bs-inverse")
    .trim();
  var bodyBg = getComputedStyle(document.body)
    .getPropertyValue("--bs-body-bg")
    .trim();

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        ticks: {
          precision: 0,
          color: "#d7d7d7",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
      y: {
        ticks: {
          precision: 0,
          color: "#d5d5d5",
        },
        grid: {
          color: "#4b4b4b",
        },
      },
    },
    plugins: {
      tooltip: {
        bodyColor: "#1e2936",
        backgroundColor: "#1e2936",
        callbacks: {
          labelTextColor: function (context) {
            return "#f8f8f8";
          },
        },
      },
      legend: {
        display: false,
        position: "bottom",
      },
    },
  };
  const [data, setData] = useState(null);
  const [allMachines, setAllMachines] = useState([]);
  const colors = [themeColor];
  const getData = async () => {
    const labels = [];
    const datasets = [];
    const res = await dataProcess.alertCountPerMachine("Location", {
      location_id: selectedLocationOverview ? selectedLocationOverview : "",
      machine_id: selectedMachineOverview ? selectedMachineOverview : "",
      start_date: dateRangeOverview?.startDate
        ? dateRangeOverview?.startDate
        : "",
      end_date: dateRangeOverview?.endDate ? dateRangeOverview?.endDate : "",
    });
    const datas = await parserAPI(res);
    const machines = datas.machines;
    let filtered = machines.filter(
      (m) => m.alertCount > 0 && m.machine_status !== "Archived"
    );
    setAllMachines(filtered);

    filtered.map((item, index) => {
      labels.push(item.machine_name);
      datasets.push(item.alertCount);
    });
    //
    const data = {
      labels,
      datasets: [
        {
          label: "# Alarm",
          data: datasets,
          backgroundColor: themeColor,
        },
      ],
    };
    setData(data);
  };
  useEffect(() => {
    getData();
  }, [selectedLocationOverview, selectedMachineOverview, dateRangeOverview]);
  useEffect(() => {
    console.log({ oke: "aa", selectedStatus, allMachines });
    const labels = [];
    const datasets = [];
    if (selectedStatus) {
      const filtered = allMachines.filter((m) => {
        return m.alert.find((al) => al.alert_status === selectedStatus);
      });

      filtered.map((item, index) => {
        labels.push(item.machine_name);
        datasets.push(item.alertCount);
      });
      //
      const data = {
        labels,
        datasets: [
          {
            label: "# Alarm",
            data: datasets,
            backgroundColor: themeColor,
          },
        ],
      };
      setData(data);
    } else {
      allMachines.map((item, index) => {
        labels.push(item.machine_name);
        datasets.push(item.alertCount);
      });
      const data = {
        labels,
        datasets: [
          {
            label: "# Alarm",
            data: datasets,
            backgroundColor: themeColor,
          },
        ],
      };
      setData(data);
    }
  }, [selectedStatus]);
  // labels will be the date of data source if it exist only one date in the label

  return data ? (
    <div style={{ position: "relative", height: "370px", width: "100%" }}>
      <Bar options={options} data={data} />
    </div>
  ) : (
    <div>
      <div className="spinner-grow text-primary"></div>
    </div>
  );
}
export default App;
